import { FBCompetitionMap } from '.';

const _noLiveText = '即将开始';

// 各赛种赛事状态映射表
export const fbSportsStatusMap: Record<string, Record<string, string>> = {
  // 足球
  [FBCompetitionMap.football.id]: {
    '1001': _noLiveText,
    '1002': '上半场',
    '1003': '中场休息',
    '1004': '下半场',
    '1005': '已结束',
    '1006': '加时 上',
    '1007': '半场',
    '1008': '加时 下',
    '1009': '加时赛结束',
    '1010': '点球大战',
    '1012': '加时赛',
    '1013': '点球大战',
    '1014': '点球结束',
    '1015': '中断',
    '1016': '废弃',
    '1011': '已结束',
  },
  // 篮球
  [FBCompetitionMap.basketball.id]: {
    '3001': _noLiveText,
    '3002': '上半场',
    '3003': '半场休息',
    '3004': '下半场',
    '3005': '第一节',
    '3006': '第一节结束',
    '3007': '第二节',
    '3008': '半场休息',
    '3009': '第三节',
    '3010': '第三节结束',
    '3011': '第四节',
    '3012': '加时赛',
    '3013': '全场结束/完赛',
    '3014': '全场结束/完赛',
    '3015': '加时赛',
    '3016': '加时赛结束',
    '3017': '延期',
    '3018': '中断',
    '3019': '废弃',
  },
  // 网球
  [FBCompetitionMap.tennis.id]: {
    '5001': _noLiveText,
    '5002': '第一盘',
    '5003': '第一盘结束',
    '5004': '第二盘',
    '5005': '第二盘结束',
    '5006': '第三盘',
    '5007': '第三盘结束',
    '5008': '第四盘',
    '5009': '第四盘结束',
    '5010': '第五盘',
    '5011': '已结束',
    '5012': '消极比赛',
    '5013': '消极比赛',
    '5014': '选手1退赛',
    '5015': '选手2退赛',
    '5016': '选手退赛',
    '5017': '选手1违规',
    '5018': '选手2违规',
    '5019': '推迟',
    '5020': '中断',
    '5021': '废弃',
  },
  // 斯诺克
  [FBCompetitionMap.snooker.id]: {
    '16001': _noLiveText,
    '16002': '进行中',
    '16003': '节休息',
    '16004': '暂停',
    '16005': '已结束',
    '16006': '散步结束',
    '16007': '散步结束',
    '16008': '选手1退赛',
    '16009': '选手2退赛',
    '16010': '选手1犯规',
    '16011': '选手2犯规',
    '16012': '推迟',
    '16013': '中断',
    '16014': '废弃',
  },
  // 棒球
  [FBCompetitionMap.baseball.id]: {
    '7001': _noLiveText,
    '7003': '第一局',
    '7004': '第一局',
    '7005': '第一局',
    '7006': '第-局结束',
    '7008': '第二局',
    '7009': '第二局',
    '7010': '第二局',
    '7011': '第二局结束',
    '7013': '第三局',
    '7014': '第三局',
    '7015': '第三局',
    '7016': '第三局结束',
    '7018': '第四局',
    '7019': '第四局',
    '7020': '第四局',
    '7021': '第四局结束',
    '7023': '第五局',
    '7024': '第五局',
    '7025': '第五局',
    '7026': '第五局结束',
    '7028': '第六局',
    '7029': '第六局',
    '7030': '第六局',
    '7031': '第六局结束',
    '7033': '第七局',
    '7034': '第七局',
    '7035': '第七局',
    '7036': '第七局结束',
    '7038': '第八局',
    '7039': '第八局',
    '7040': '第八局',
    '7041': '第八局结束',
    '7043': '第九局',
    '7044': '第九局',
    '7045': '第九局',
    '7046': '第九局结束',
    '7048': '额外局',
    '7049': '额外局',
    '7050': '额外局',
    '7051': '已结束',
    '7052': '中断',
    '7053': '废弃',
    '7054': '已结束',
  },
  // 排球
  [FBCompetitionMap.volleyball.id]: {
    '13001': _noLiveText,
    '13002': '第一局',
    '13003': '第一局结束',
    '13004': '第二局',
    '13005': '第二局结束',
    '13006': '第三局',
    '13007': '第三局结束',
    '13008': '第四局',
    '13009': '第四局结束',
    '13010': '第五局',
    '13011': '第五局结束',
    '13012': '第六局',
    '13013': '第六局结束',
    '13014': '第七局',
    '13015': '已结束',
    '13016': '金局',
    '13017': '金局',
    '13018': '金局结束',
    '13019': '散步结束',
    '13020': '散步结束',
    '13021': '选手1退赛',
    '13022': '选手2退赛',
    '13023': '延期',
    '13024': '中断',
    '13025': '废弃',
  },
  // 羽毛球
  [FBCompetitionMap.badminton.id]: {
    '47001': _noLiveText,
    '47002': '第一局',
    '47003': '第一局结束',
    '47004': '第二局',
    '47005': '第二局结束',
    '47006': '第三局',
    '47007': '第三局结束',
    '47008': '第四局',
    '47009': '第四局结束',
    '47010': '第五局',
    '47015': '已结束',
    '47016': '消极比赛',
    '47017': '消极比赛',
    '47018': '选手1退赛',
    '47019': '选手2退赛',
    '47020': '选手1犯规',
    '47021': '选手2犯规',
    '47022': '推迟',
    '47023': '中断',
    '47024': '废弃',
  },
  // 乒乓球
  [FBCompetitionMap.pingPong.id]: {
    '15001': _noLiveText,
    '15002': '第一局',
    '15003': '第一局结束',
    '15004': '第二局',
    '15005': '第二局结束',
    '15006': '第三局',
    '15007': '第三局结束',
    '15008': '第四局',
    '15009': '第四局结束',
    '15010': '第五局',
    '15011': '第五局结束',
    '15012': '第六局',
    '15013': '第六局结束',
    '15014': '第七局',
    '15015': '已结束',
    '15016': '消极比赛',
    '15017': '消极比赛',
    '15018': '选手1退赛',
    '15019': '选手2退赛',
    '15020': '选手1犯规',
    '15021': '选手2犯规',
    '15022': '推迟',
    '15023': '中断',
    '15024': '废弃',
  },
  // 冰球
  [FBCompetitionMap.puck.id]: {
    '2001': _noLiveText,
    '2002': '第一节',
    '2003': '中场休息',
    '2004': '第二节',
    '2005': '中场休息',
    '2006': '第三节',
    '2007': '已结束',
    '2008': '加时',
    '2009': '加时',
    '2010': '加时结束',
    '2011': '点球',
    '2012': '点球',
    '2013': '点球结束',
    '2014': '中断',
    '2015': '废弃',
    '2016': '已结束',
  },
};

/**
 * fb团队得分类型映射
 */
export const fbTeamScoreType: Record<string, number> = {
  score: 5,
  corner: 6,
  yellowCard: 7,
  redCard: 8,
  booking: 9,
  points: 11,
  frameScore: 12,
  breakScore: 13,
  homeRun: 14,
  hit: 15,
  touchdown: 16,
  fieldGoal: 17,
  kill: 127,
  setScore: 5556,
  ace: 5557,
  doubleFaultScore: 5558,
  gameScore: 5559,
};
